module.exports = __webpack_public_path__ + "media/images/gallery/constellations/rn_layer_off-5a953cadf285d4150474cbb77cf3790d.jpg";